<div class="delete-dialog">
  <h1 mat-dialog-title>Account löschen</h1>
  <mat-dialog-content>
    <p class="m0">
      Ihr Account wird inklusive aller Daten unwiderruflich gelöscht, auch Ihre Sammelmappen und deren Freigaben.
      Bitte bestätigen Sie mit Ihrer E-Mail-Adresse und Ihrem Passwort.
    </p>

    <form (ngSubmit)="delete()" [formGroup]="form" class="delete-form" id="delete-account-form">
      <mat-form-field appearance="outline">
        <mat-label>E-Mail</mat-label>
        <input autocomplete="username" formControlName="email" matInput required type="email">
        @if (form.controls.email.hasError('email')) {
          <mat-error>Ungültige E-Mail-Adresse</mat-error>
        }
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Passwort</mat-label>
        <input [type]="hidePassword ? 'password' : 'text'" autocomplete="current-password" formControlName="password"
               matInput required>
        <button (click)="hidePassword = !hidePassword" [attr.aria-label]="hidePassword ? 'Passwort anzeigen' : 'Passwort verbergen'"
                mat-icon-button matSuffix type="button">
          <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
      </mat-form-field>
    </form>

    @if (errorMessage) {
      <p class="warning m0">{{ errorMessage }}</p>
    }
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button [mat-dialog-close]="false" mat-raised-button type="button">Abbrechen</button>
    <button [disabled]="deleting" color="warn" form="delete-account-form" mat-raised-button type="submit">
      Account löschen
    </button>
  </mat-dialog-actions>
</div>
